export enum SortDirectionEnums {
  ASCENDING = 0,
  DESCENDING = 1,
}
